import { Badge } from '@/components/ui/badge'

/**
 * Generic help content for content types without specific guidance
 */
export function GenericHelp({ contentType }: { contentType: string }) {
    // Format the content type name for display
    const formattedContentType = contentType
        .replace('_', ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    
    return (
        <>
            <h3 className="font-medium text-lg mb-2">Publishing {formattedContentType}</h3>
            <ol className="list-decimal pl-5 space-y-3 mb-4">
                <li>
                    <strong>Set Status to Published:</strong> Use the status dropdown at the top of the page to mark this content as 
                    <Badge className="ml-1 mr-1 font-normal">Published</Badge>.
                </li>
                <li>
                    <strong>Share with Others:</strong> Use the <Badge variant="outline" className="ml-1 mr-1 font-normal">Share & Embed</Badge> button to get embed codes or direct URLs.
                </li>
                <li>
                    <strong>Copy Content:</strong> Use the <Badge variant="outline" className="ml-1 mr-1 font-normal">Copy Source</Badge> button to copy the raw content for use in other platforms.
                </li>
                <li>
                    <strong>Content Integration:</strong> Embed the content into your existing platforms using the provided embedding tools.
                </li>
            </ol>
        </>
    )
}